import { isPackAllowedForPatient, isOwnedPackAllowedForPatient, isPackAvailableForMode, } from "../../components/appointment/utils/sessionPacks";
const EMPTY_FORM = {
    fullName: "",
    gender: "",
    city: "",
    age: "",
    email: "",
    address: "",
    zipCode: "",
};
export const createPatientSlice = (set, get) => ({
    verifiedPatients: [],
    activeSessionPacks: [],
    patientsLoading: false,
    patientTab: "existing",
    selectedPatient: null,
    selectedActiveSessionPack: null,
    newPatientForm: { ...EMPTY_FORM },
    setVerifiedData: (patients, packs) => set((state) => ({
        verifiedPatients: patients,
        activeSessionPacks: packs,
        patientTab: patients.length === 0
            ? "new"
            : state.verifiedPatients.length === 0
                ? "existing"
                : state.patientTab,
    })),
    setPatientsLoading: (v) => set({ patientsLoading: v }),
    setPatientTab: (tab) => set((state) => ({
        patientTab: tab,
        followUpSelected: state.followUpGrid && state.followUpSelected,
    })),
    setSelectedPatient: (patient) => set((state) => state.selectedPatient?.id === patient?.id
        ? { selectedPatient: patient }
        : {
            selectedPatient: patient,
            followUpSelected: state.followUpGrid && state.followUpSelected,
        }),
    setSelectedActiveSessionPack: (pack) => set(pack
        ? { selectedActiveSessionPack: pack, selectedPack: null }
        : { selectedActiveSessionPack: null }),
    updateNewPatientForm: (fields) => set((state) => ({
        newPatientForm: { ...state.newPatientForm, ...fields },
    })),
    continueToSummary: () => {
        const { patientTab, selectedPatient, newPatientForm, selectedPack, selectedActiveSessionPack, activeSessionPacks, consultationMode, } = get();
        if (patientTab === "existing" && !selectedPatient) {
            set({ bookingError: "Please select a patient" });
            return;
        }
        if (patientTab === "new") {
            if (!newPatientForm.fullName.trim()) {
                set({ bookingError: "Please enter patient name" });
                return;
            }
            if (!newPatientForm.gender) {
                set({ bookingError: "Please select gender" });
                return;
            }
            if (!newPatientForm.city.trim()) {
                set({ bookingError: "Please enter city" });
                return;
            }
        }
        if (selectedPack &&
            !isPackAllowedForPatient(selectedPack, patientTab, selectedPatient, activeSessionPacks)) {
            set({
                selectedPack: null,
                bookingError: "That session pack can only be used by the patient who purchased it. It has been removed — please choose a plan again.",
            });
            return;
        }
        if (selectedActiveSessionPack) {
            if (!isOwnedPackAllowedForPatient(selectedActiveSessionPack, patientTab, selectedPatient)) {
                set({
                    selectedActiveSessionPack: null,
                    bookingError: "That session pack can only be used by the patient who purchased it. It has been removed — please choose again.",
                });
                return;
            }
            if (!isPackAvailableForMode(selectedActiveSessionPack, consultationMode)) {
                set({
                    selectedActiveSessionPack: null,
                    bookingError: "That session pack cannot be used for this consultation type. It has been removed — please choose again.",
                });
                return;
            }
        }
        set({ bookingError: null, currentStep: "summary" });
    },
});
